const SvgComputeandServers3 = (props) => (
  <>
    <path fill={props.p20} d="M0 192V0h48v192zM72 192V0h48v192zM144 192V0h48v192z" />
  </>
);

export default SvgComputeandServers3;
